import { renderSelectReadValuesExpressionSelectValueTemplate } from '@next-adapter/templates/renderers/generators/form/form-shared/select-read-values-expression.js'
export function selectReadValuesExpression(fieldName: string, dataSource = 'initialData'): string {
  return renderSelectReadValuesExpressionSelectValueTemplate({
    dataSource: dataSource,
    fieldName: fieldName
  })
}
